/* @vue/component */
export default {
  name: 'filterable',

  props: {
    noDataText: {
      type: String,
      default: '$vuetify.noDataText'
    }
  }
}
